import Vue from 'vue';
import Vuex, { Commit } from 'vuex';
import storeConstants from '@/utils/constants/StoreConstants'
import { UserAuthenticatedModel } from '@/user/models/UserAuthenticatedModel';
import userService from '@/user/services/UserService'
import subscriberService from '@/subscriber/services/SubscriberService'
import subscriberManager from '@/subscriber/managers/SubscriberManager'
import { SubscriberModel } from './subscriber/models/SubscriberModel';
import storeService from './store/services/StoreService';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userAuthenticated: new UserAuthenticatedModel(),
    subscriberList: [],
    storeList: [],
    subscriber: new SubscriberModel(),
  },
  getters: {
    hasAtLeastOneSubscriber: (state) => {
      return state.subscriberList.length > 0
    },
    hasMoreThanOneSubscriber: (state) => {
      return state.subscriberList.length > 1
    },
    hasMoreThanOneStore: (state) => {
      return state.storeList.length > 1
    },
    hasAtLeastOneStore: (state) => {
      return state.storeList.length > 0
    },
  },
  mutations: {
    [storeConstants.mutations.SET_AUTHENTICATED_USER](state, user) {
      state.userAuthenticated = user
    },
    [storeConstants.mutations.SET_AUTHENTICATED_USER_ROLES](state, userRoles) {
      state.userAuthenticated.setRoles(userRoles)
    },
    [storeConstants.mutations.SET_SUBSCRIBER_LIST](state, subscriberList) {
      state.subscriberList = subscriberList
    },
    [storeConstants.mutations.SET_STORE_LIST](state, storeList) {
      state.storeList = storeList
    },
    [storeConstants.mutations.SET_SUBSCRIBER](state, subscriber) {
      state.subscriber = subscriber
    },
  },
  actions: {
    async [storeConstants.actions.GET_AUTHENTICATED_USER]({commit}) {
      return userService.getUserAuthenticated()
        .then((user) => {
          commit(storeConstants.mutations.SET_AUTHENTICATED_USER, user)
        })
    },
    async [storeConstants.actions.GET_AUTHENTICATED_USER_ROLES]({commit}) {
      return userService.getUserAuthenticatedRoles()
        .then((userRoles) => {
          commit(storeConstants.mutations.SET_AUTHENTICATED_USER_ROLES, userRoles)
        })
    },
    [storeConstants.actions.GET_SUBSCRIBER_LIST]({commit}) {
      return subscriberService.getSubscribers()
        .then((subscribers) => {
          if (!subscribers.length) {
            return
          }

          commit(storeConstants.mutations.SET_SUBSCRIBER_LIST, subscribers)

          if (subscribers.length === 1) {            
            selectSubscriber(commit, subscribers[0])
            return
          }

          for (const s of subscribers) {
            if (s.hasSamePublicKey(subscriberManager.getPublicKeyFromStorage())) {
              selectSubscriber(commit, s)
              return
            }
          }

          selectSubscriber(commit, subscribers[0])
        })
    },
    [storeConstants.actions.GET_STORE_LIST]({commit}) {
      return storeService.getStores()
        .then((stores) => {
          commit(storeConstants.mutations.SET_STORE_LIST, stores)
        })        
    },
    [storeConstants.actions.SET_SUBSCRIBER]({commit}, subscriber) {
      selectSubscriber(commit, subscriber)
    },   
  },
});

function selectSubscriber(commit:Commit, subscriber:SubscriberModel):void {
  subscriberManager.selectSubscriber(subscriber)
  commit(storeConstants.mutations.SET_SUBSCRIBER, subscriber)
}
